<template>
    <div class="td-column-dumy">
        <div class="top">
            <slot/>
        </div>
        <div class="bottom">

        </div>
    </div>
</template>

<script>
export default {
    name: 'TopLineTd',
};
</script>
